import {
  authenticatedGet,
  authenticatedPost,
  authenticatedPut,
} from '../../api/authenticatedFetch';

const BASE = '/api/v1';

// --- Roles ---

export const listRoles = async () => {
  return authenticatedGet(`${BASE}/roles`);
};

// --- Users ---

/**
 * @param {{ q?: string, status?: string, role?: string, limit?: number, cursor?: number }} params
 */
export const listUsers = async (params = {}) => {
  const query = {};
  if (params.q) query.q = params.q;
  if (params.status) query.status = params.status;
  if (params.role) query.role = params.role;
  if (params.limit) query.limit = params.limit;
  if (params.cursor) query.cursor = params.cursor;
  return authenticatedGet(`${BASE}/users`, query);
};

export const getUser = async (id) => {
  return authenticatedGet(`${BASE}/users/${id}`);
};

/**
 * @param {{ email: string, first_name: string, last_name: string, function?: string, roles: string[], send_invite: boolean }} body
 */
export const createUser = async (body) => {
  return authenticatedPost(`${BASE}/users`, body);
};

/**
 * @param {number|string} id
 * @param {{ first_name: string, last_name: string, function?: string, roles: string[] }} body
 */
export const updateUser = async (id, body) => {
  return authenticatedPut(`${BASE}/users/${id}`, body);
};

export const suspendUser = async (id) => {
  return authenticatedPost(`${BASE}/users/${id}/suspend`, {});
};

export const reactivateUser = async (id) => {
  return authenticatedPost(`${BASE}/users/${id}/reactivate`, {});
};

export const resendInvite = async (id) => {
  return authenticatedPost(`${BASE}/users/${id}/invite`, {});
};

// --- Invites ---

/**
 * @param {string} token
 */
export const acceptInvite = async (token) => {
  return authenticatedPost(`${BASE}/invites/accept`, { token });
};
